module.exports = __webpack_public_path__ + "img/scan-complete.46752f3e.svg";